import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { ServicosUtilidadesService } from '../../servicos-utilidades/servicos-utilidades.service';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-enviar-comprovante-email',
  templateUrl: './enviar-comprovante-email.component.html',
  styleUrls: ['./enviar-comprovante-email.component.css']
})
export class EnviarComprovanteEmailComponent implements OnInit {

  marcacao: any;

  formularioDeEnvioDeComprovantePorEmail: FormGroup;

  tipoMarcacao: TipoMarcacaoEnum = TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA;

  constructor(private servicosUtilidadesService: ServicosUtilidadesService, private router: Router,
    private formBuilder: FormBuilder, private dialog: MatDialog) {

    this.formularioDeEnvioDeComprovantePorEmail = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

  }

  ngOnInit(): void {
    this.tipoMarcacao = history.state.tipoMarcacao;

    if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {
      this.marcacao = history.state.marcacaoConsulta;
    } else if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {
      this.marcacao = history.state.marcacaoProcedimento;
    }
  }

  onSubmit() {
    this.enviarComprovantePorEmail();
  }

  enviarComprovantePorEmail(): void {
    let email: string = this.formularioDeEnvioDeComprovantePorEmail.value.email;

    if (this.marcacao && this.marcacao.pk &&
      this.marcacao.pk.idPaciente && this.tipoMarcacao && email) {

      if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {

        this.servicosUtilidadesService.enviarEmailAgendamentoConsulta(this.marcacao, email)
          .subscribe(data => {
            // console.log(data)

            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                title: 'Info',
                message: 'E-mail enviado com sucesso!'
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/marcacaoConsulta/marcacaoConsultaRealizada'], { state: { marcacaoConsulta: this.marcacao } });
            });
          }, error => {
            console.log(error);
          });
      } else if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {

        let local: string = this.getUnidade(this.marcacao.planoSaude.nome);

        this.servicosUtilidadesService.enviarEmailAgendamentoProcedimento(this.marcacao, email, environment.appAlias, local)
          .subscribe(data => {
            // console.log(data)

            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                title: 'Info',
                message: 'E-mail enviado com sucesso!'
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/marcacaoConsulta/marcacaoProcedimentoRealizado'], { state: { marcacaoProcedimento: this.marcacao } });
            });
          }, error => {
            console.log(error);
          });
      } else {
        this.dialog.open(ErrorDialogComponent, {
          data: {
            title: 'Erro',
            message: 'Tipo de Marcação não encontrado!'
          }
        });
      }
    } else if (!email) {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'E-mail não encontrado!'
        }
      });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Marcação não encontrada!'
        }
      });
    }
  }

  telaAnterior(): void {
    if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {
      this.router.navigate(['/marcacaoConsulta/marcacaoConsultaRealizada'], { state: { marcacaoConsulta: this.marcacao } });
    } else if ((this.tipoMarcacao as TipoMarcacaoEnum) === TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {
      this.router.navigate(['/marcacaoConsulta/marcacaoProcedimentoRealizado'], { state: { marcacaoProcedimento: this.marcacao } });
    }
  }

  getUnidade(nomePlanoSaude: string): string {
    return environment.appAlias != 'COPE_AGENDA' ? nomePlanoSaude : 'Boa Vista';
  }
}
